import { render, staticRenderFns } from "./SidebarItems.vue?vue&type=template&id=0191b014&"
import script from "./SidebarItems.vue?vue&type=script&lang=ts&"
export * from "./SidebarItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports